import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { HeroPage } from "./components/HeroPage";
import { Dashboard } from "./components/Dashboard";
import { CompanyDetail } from "./components/CompanyDetail";

const MainApp = () => {
  const [showHero, setShowHero] = useState(true);
  const navigate = useNavigate();

  const handleEnter = () => {
    setShowHero(false);
    navigate('/dashboard');
  };

  const handleBackToHero = () => {
    setShowHero(true);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#050505]">
      <AnimatePresence mode="wait">
        {showHero ? (
          <HeroPage key="hero" onEnter={handleEnter} />
        ) : (
          <Routes>
            <Route 
              path="/dashboard" 
              element={<Dashboard onBack={handleBackToHero} />} 
            />
            <Route 
              path="/company/:id" 
              element={<CompanyDetail />} 
            />
            <Route 
              path="*" 
              element={<Dashboard onBack={handleBackToHero} />} 
            />
          </Routes>
        )}
      </AnimatePresence>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <MainApp />
    </BrowserRouter>
  );
}

export default App;
